import { Component, HostBinding, Input, NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
class NgxJsonLdComponent {
    /**
     * @param {?} sanitizer
     */
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        this.jsonLD = this.getSafeHTML(changes["json"].currentValue);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    getSafeHTML(value) {
        const /** @type {?} */ json = value ? JSON.stringify(value, null, 2).replace(/<\/script>/g, '<\\/script>') : '';
        const /** @type {?} */ html = `<script type="application/ld+json">${json}</script>`;
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
NgxJsonLdComponent.ɵfac = function NgxJsonLdComponent_Factory(t) { return new (t || NgxJsonLdComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DomSanitizer)); };
NgxJsonLdComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxJsonLdComponent, selectors: [["ngx-json-ld"]], hostVars: 1, hostBindings: function NgxJsonLdComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("innerHTML", ctx.jsonLD, ɵngcc0.ɵɵsanitizeHtml);
    } }, inputs: { json: "json" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function NgxJsonLdComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
NgxJsonLdComponent.ctorParameters = () => [
    { type: DomSanitizer, },
];
NgxJsonLdComponent.propDecorators = {
    "json": [{ type: Input },],
    "jsonLD": [{ type: HostBinding, args: ['innerHTML',] },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxJsonLdComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-json-ld',
                template: ''
            }]
    }], function () { return [{ type: ɵngcc1.DomSanitizer }]; }, { jsonLD: [{
            type: HostBinding,
            args: ['innerHTML']
        }], json: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxJsonLdModule {
}
NgxJsonLdModule.ɵfac = function NgxJsonLdModule_Factory(t) { return new (t || NgxJsonLdModule)(); };
NgxJsonLdModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxJsonLdModule });
NgxJsonLdModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
/** @nocollapse */
NgxJsonLdModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxJsonLdModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [NgxJsonLdComponent],
                exports: [NgxJsonLdComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxJsonLdModule, { declarations: function () { return [NgxJsonLdComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxJsonLdComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */

export { NgxJsonLdModule, NgxJsonLdComponent as ɵa };

//# sourceMappingURL=ngx-json-ld.js.map